import React from 'react'
import { FinanceInventoryContext } from './finance-inventory-context'

function FinanceInventoryProvider(props: {children: React.ReactElement}) {
  return (
    <FinanceInventoryContext.Provider value={{
      tempData: "hello"
    }}>
      {props.children}
    </FinanceInventoryContext.Provider>
  )
}

export default FinanceInventoryProvider